import ThirdOverview from './ThirdOverview'

class ProspectOverview extends ThirdOverview {

    constructor() {
        super()
        this.linkedtype = 'prospect'
        this.setMappingName()
    }
}

export default ProspectOverview